<template>
    <div id="contenedor-listado-auditorias-desktop">
    <v-data-table :headers="headers" :items="auditorias" :items-per-page="10">
      <template v-slot:[`item.nombre`]="{ item }">
        <router-link
          :to="{ name: 'auditoriaInformes', params: { idAuditoria: item.id } }"
        >
          {{ item.nombre }}
        </router-link>
      </template>
      <template v-slot:[`item.numeroInformes`]="{ item }">
        <v-chip  color="base5">
        {{item.informes.length}}
        </v-chip>
      </template>
      <template v-slot:[`item.totalObservaciones`]="{ item }">
        <v-chip  color="base5">
        {{item.totalObservaciones}}
        </v-chip>
      </template>
      <template v-slot:[`item.totalObservacionesPorSolventar`]="{ item }">
           <v-chip
            :color="item.colorPorSolventar" dark
            v-if="item.totalObservacionesPorSolventar > 0">
            {{item.totalObservacionesPorSolventar}}
            </v-chip>
            <v-chip
            :color="item.colorPorSolventar"
            v-else>
            {{item.totalObservacionesPorSolventar}}
            </v-chip>
      </template>
      <template v-slot:[`item.enteFiscalizador`]="{ item }">
        {{item.enteFiscalizador.descripcion}}
      </template>
      <template v-slot:[`item.periodoDel`]="{ item }">
        {{ new Date(`${item.periodoDel} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.periodoAl`]="{ item }">
        {{ new Date(`${item.periodoAl} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-slot:[`item.anexo`]="{ item }">
        <v-tooltip v-if="item.fileData && item.fileData !==''? true:false" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="red"
              icon
              v-bind="attrs"
              v-on="on"
              @click="verPdf(item)">
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <span>Ver PDF</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :auditoria="item"></opciones>
      </template>
    </v-data-table>
    <!-- Ventana Editar Auditoria -->
      <v-dialog
        v-if="mostrarEditarAuditoria"
        v-model="mostrarEditarAuditoria"
        width="600"
        persistent>
        <EditarAuditoria
        :auditoriaEditar="estaAuditoria"
        v-on:cerrar="mostrarEditarAuditoria=!mostrarEditarAuditoria"/>
      </v-dialog>
     <!-- Ventana Eliminar Auditoria -->
      <v-dialog
        v-if="mostrarEliminarAuditoria"
        v-model="mostrarEliminarAuditoria"
        width="600"
        persistent>
        <EliminarAuditoria
        :auditoria="estaAuditoria"
        v-on:cerrar="mostrarEliminarAuditoria=!mostrarEliminarAuditoria"/>
      </v-dialog>
      <!-- Ventana Ver Pdf Auditoria -->
      <v-dialog
        v-if="mostrarVerPdfAuditoria"
        v-model="mostrarVerPdfAuditoria"
        persistent
        scrollable
        width="750px">
        <v-card>
          <v-card-title>
            {{ estaAuditoria.nombre }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="mostrarVerPdfAuditoria = !mostrarVerPdfAuditoria">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <VerPdfAuditoria :rutaArchivo="estaAuditoria.fileData"/>
          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Ventana Agregar Informe -->
      <v-dialog
        v-if="mostrarAgregarInforme"
        v-model="mostrarAgregarInforme"
        width="600"
        persistent>
        <AgregarInforme
        :auditoria="estaAuditoria"
        v-on:cerrar="mostrarAgregarInforme=!mostrarAgregarInforme"/>
      </v-dialog>
  </div>
</template>
<script>
import FechaHumano from '@/components/FechaHumano.vue';
import EliminarAuditoria from '@/components/administracion/auditorias/auditoria/Eliminar.vue';
import EditarAuditoria from '@/components/administracion/auditorias/auditoria/Editar.vue';
import VerPdfAuditoria from '@/components/administracion/auditorias/auditoria/verPdf.vue';
import AgregarInforme from '@/components/administracion/auditorias/informes/Nuevo.vue';
import eventBus from '@/helpers/eventBus';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoAuditoriasDesktop',
  props: {
    auditorias: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    EliminarAuditoria,
    EditarAuditoria,
    FechaHumano,
    VerPdfAuditoria,
    AgregarInforme,
  },
  data() {
    return {
      mostrarAgregarInforme: false,
      mostrarEditarAuditoria: false,
      mostrarEliminarAuditoria: false,
      mostrarVerPdfAuditoria: false,
      estaAuditoria: {},
      headers: [
        { text: 'Ejercicio', value: 'ejercicio', sortable: true },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Informes', align: 'center', value: 'numeroInformes' },
        { text: 'Observaciones', align: 'center', value: 'totalObservaciones' },
        { text: 'Por Solventar', align: 'center', value: 'totalObservacionesPorSolventar' },
        { text: 'F. Inicio', value: 'periodoDel' },
        { text: 'F. Término', value: 'periodoAl' },
        { text: 'Ente Fiscalizador', value: 'enteFiscalizador' },
        {
          text: 'Anexo', value: 'anexo', align: 'center', sortable: false,
        },
        /* { text: 'Registro', value: 'createdAt' }, */
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  mounted() {
    eventBus.$on('editar-auditoria', (auditoria) => {
      this.mostrarEditarAuditoria = true;
      this.estaAuditoria = auditoria;
    });
    eventBus.$on('eliminar-auditoria', (auditoria) => {
      this.mostrarEliminarAuditoria = true;
      this.estaAuditoria = auditoria;
    });
    eventBus.$on('ver-pdf-auditorias', (auditoria) => {
      this.mostrarVerPdfAuditoria = true;
      this.estaAuditoria = auditoria;
    });
    eventBus.$on('agregar-auditoria-informe', (auditoria) => {
      this.mostrarAgregarInforme = true;
      this.estaAuditoria = auditoria;
    });
  },
  methods: {
    verPdf(item) {
      this.estaAuditoria = item;
      this.mostrarVerPdfAuditoria = true;
    },
  },
};
</script>
